// array from 2 to 19 excluding 10 and 11
const ALL_TABLES = [2, 3, 4, 5, 6, 7, 8, 9, 12, 13, 14, 15, 16, 17, 18, 19];

export default ALL_TABLES;
